import { useNavigate } from 'react-router-dom';


import {Alert, AlertTitle, Box, Button, CircularProgress, IconButton,
    Popover, Select, Snackbar,
    Stack, ThemeProvider, Typography} from '@mui/material';


import LoadingButton from '@mui/lab/LoadingButton';
import { useParams } from "react-router-dom";

import { useState, useEffect, useRef, } from 'react';

import { WeatherUnitsSelector } from '../components/templateEditor';

import { Icon as Iconify } from '@iconify/react';
import axios from 'axios';
import { lionIcons } from '../components/helpersIcons';

import TemplateEditor from '../components/templateEditor';

import  SnippetHtmlViewer  from '../components/snippetHtmlViewer';

//import TemplateGalleryViewer from "../commonComponents/CC_templateGallery";
import {TemplateGalleryViewer} from '../commonComponents/templateGallery'

import { CcStepper2} from "../commonComponents/stepper"
import {ccColorDarkTeal, ccColorTeal, lionObjectsColors}  from "../components/helpersStyles";
import {FileSelector, InputText} from "../commonComponents/inputFields"

import { getErrorListFromYupError, getErrorMessage, snippetDataValidationSchemaWeatherForecasts } from '../components/helperErrors'

import { CcLoader } from '../commonComponents/generalComponents';



export function ForecastsElementManager(props) {
  /*
  props:
  templateId: (must be provided for new )
  snippetInfo: (must be provided for edits )

  onChange: returns all the snippet info
  */

  //const {settings, setSettings} = useContext(SettingsContext);

  const [snippetName, setSnippetName] = useState('')
  const [snippetDesc, setSnippetDesc] = useState('')
  const [snippetHref, setSnippetHref] = useState('')
  const [templateId, setTemplateId] = useState(undefined);
  const [snippetSettings, setSnippetSettings] = useState({units: 'metric'})
  const [templateSize, setTemplateSize] = useState(undefined)


  useEffect(() => {
    if (props.templateId === undefined && props.snippetInfo === undefined) return;

    if (props.templateId) {setTemplateId(props.templateId); getTemplateSize(props.templateId)}
    if (props.snippetInfo) { //we are in edit
      setSnippetName(props.snippetInfo.snippetName)
      setSnippetDesc(props.snippetInfo.snippetDesc)
      setSnippetHref(props.snippetInfo.href)
      setTemplateId(props.snippetInfo.templateId)
      getTemplateSize(props.snippetInfo.templateId)
      if (props.snippetInfo.snippetSettings) setSnippetSettings(props.snippetInfo.snippetSettings)
    }
    else {
    }

  }, [props.templateId, props.snippetInfo])


  const prepareDataToPost = (updatePropName, updatePropValue) => {
    const result = {snippetId: 0, snippetName: '', snippetDesc: '', 
    labels: [{labelId: 0, labelName: ''}], href: '',
    snippetTypeId: 18,
    filters: [], orderBy: [],
    dataConnectionId: 0, templateId: 0, dataConnectionInfo: {}};

    result.templateId = templateId;
    result.snippetName = snippetName;
    result.snippetDesc = snippetDesc;
    result.href = snippetHref;
    result.snippetSettings = snippetSettings

    if (updatePropName) {
      result[updatePropName] = updatePropValue;
      //console.log(result)
  }
    return result;
  }

  const getTemplateSize = async (templateId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Templates/size/${templateId}`;
      const response = await axios.get(url);
      let data = response.data;

      //console.log(data)
      setTemplateSize(data)

    } catch (error) {
      console.log(error);
    }
  }


  const handleSnippetNameChange = (newValue) => {
    setSnippetName(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetName', newValue))
  }
  const handleSnippetDescChange = (newValue) => {
    setSnippetDesc(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetDesc', newValue))
  }
  const handleSnippetHrefChange = (newValue) => {
    
    setSnippetHref(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('href', newValue))
  }
const handleSnippetSettingsChange = (propName, propValue) => {
  const newSettings = {...snippetSettings, [propName]:  propValue}

  setSnippetSettings(newSettings)
  if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSettings))
}
const handleDefaultImageChange = (dataURL) => {
  let imgB64 = ''

  /*
  if (dataURL && dataURL !== '') {
    const dataParts = dataURL.split('base64,')
    imgB64 = dataParts[1]
  }
   */
  imgB64 = dataURL;
  handleSnippetSettingsChange('defaultImage', imgB64)

}


  return <div>
  <div className='flex flex-col gap-4 justify-center items-center'>
      <div className=" w-1/2 mt-10 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
    <div className="sm:col-span-3">
      <InputText
            displayName="Name"
            value={snippetName}
            onChange={(val) => {handleSnippetNameChange(val);}}
            error={getErrorMessage(props.validationErrorsList, 'snippetName')}
      />
    </div>

    <div className="sm:col-span-3">
      <InputText
            displayName="Description"
            value={snippetDesc}
            onChange={(val) => {handleSnippetDescChange(val);}}
            error={getErrorMessage(props.validationErrorsList, 'snippetDesc')}
      />
    </div>


    <div className="sm:col-span-6">
      <InputText
            displayName="Href"
            value={snippetHref}
            onChange={(val) => {handleSnippetHrefChange(val);}}
            error={getErrorMessage(props.validationErrorsList, 'href')}
      />

    </div>

{/* 
    <div className="sm:col-span-6 font-poppins">
      <div className='text-sm font-poppins font-medium leading-6 text-gray-900'>Unit system</div>
      <div className='w-28'>
        <WeatherUnitsSelector units={snippetSettings.units}
          onChange={(units) => handleSnippetSettingsChange('units', units)}
        />
      </div>
    </div>
*/}
  
    <div className="sm:col-span-6 font-poppins text-sm font-medium text-gray-900">
      <div className='mb-2'>Default Image</div>
      {templateSize && 
          <div className='bg-ccColorYellow text-ccColorDarkTeal text-sm font-semibold rounded w-fit px-2 py-1'>Suggested size: {templateSize.width} x {templateSize.height} px</div>
      }
      <div className='mt-2 flex flex-row gap-x-4 items-center'>
        {(snippetSettings.defaultImage === undefined || snippetSettings.defaultImage === '') && <>
            <FileSelector noDeleteButton
              text="Upload"
              onChange={handleDefaultImageChange}
            />
            <div className='text-red-600'>
                {getErrorMessage(props.validationErrorsList, 'defaultImage')}
              </div>
            </>

        }
        {snippetSettings.defaultImage && snippetSettings.defaultImage !== '' &&
          <div className='bg-slate-200 rounded p-4  w-[400px] h-[300px] flex justify-center'>
            <div className='relative h-full' >

                <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${snippetSettings.defaultImage}`} />


            </div>


          </div>
        }
        {snippetSettings.defaultImage && snippetSettings.defaultImage !== '' &&
            <div className=' hover:bg-slate-100 rounded-full hover:cursor-pointer p-1 h-fit'
            onClick={() => handleSnippetSettingsChange('defaultImage', '')}
            >
            <Iconify icon={lionIcons.Icon_Actions_Cancel} width={32} />
        </div>     
        }

      </div>
      
    </div>


</div>

</div>
  </div>
}


export default function ForecastsWorkFlow(props) {


const initialState = {snippetId: 0, snippetName: '', snippetDesc: '', 
                   labels: [{labelId: 0, labelName: ''}], href: '',
                   snippetTypeId: 1,
                   filters: [], orderBy: [],
                   snippetSettings: {units: 'metric'},
                   dataConnectionId: 0, templateId: 0, dataConnectionInfo: {}};


const routeParams = useParams();
const [workflowDataConnectionId, setWorkflowDataConnectionId] = useState(null);
const [workflowTemplatePreviewImages, setWorkflowTemplatePreviewImages] = useState(null); // set 1 time only. it contains info to get all preview images url for CA templates. It is passed to SnippetCAEditor as a prop



const [activeStep, setActiveStep] = useState(0);
const [snippetInfo, setSnippetInfo] = useState(initialState);
const [submitLoading, setSubmitLoading] = useState(false);
// templateMetadata: every time user selects a template we need to check for its feed's metadata so that we can populate the filters and order by combos..              
const [templatesMetadata, setTemplatesMetadata] = useState({}); // dictionary {templateId: {metadata: ''}}

const [showSuccessMsg, setShowSuccessMsg] = useState(false);
const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
const [showErrorMsg, setShowErrorMsg] = useState(false);
const [showLoader, setShowLoader] = useState(false);
const [snackBarClipboardOpen, setSnackBarClipboardOpen] = useState(false);

const [preEditorProps, setPreEditorProps] = useState({});
const [templateId, setTemplateId] = useState(undefined);
const [templateMetadata, setTemplateMetadata] = useState(undefined);

const [weatherModeTag, setweatherModeTag] = useState('city') //either city or airport. For now only city is implemented. This is only used to show the desired merge codes in the tag

const [addMode, setAddMode] = useState(false); //only used in an account with no feed to give a way to create a new feed from this page
const [activeErrorList, setActiveErrorList] = useState([]);

const navigate = useNavigate();


// load data for edit mode -----
const getSnippetInfo = async (snippetId) => {
   try {
         const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
         const response = await axios.get(url);
       setSnippetInfo(response.data);

      } catch (error) {
     console.log(error);
   }
 }

const getTemplateMetadata = async (templateId) => {
  if (Object.prototype.hasOwnProperty.call(templatesMetadata, templateId)) {
    // console.log('already loaded');
    return;
  }

  try {
        const url = `${process.env.REACT_APP_LION_API_URL}/Templates/info/${templateId}`;
        const response = await axios.get(url);
      
 
        const newTemplatesMetadata = {...templatesMetadata, [templateId]:{'metadata': response.data }}
        setTemplatesMetadata(newTemplatesMetadata);
        console.log(newTemplatesMetadata)
      
  } catch (error) {
    console.log(error);
  }
 }

 
const getTemplatePreviewImagesInfo = async (preselectId) => {
    try {
          const url = `${process.env.REACT_APP_LION_API_URL}/Templates/previewImages`;
          const response = await axios.get(url);
          setWorkflowTemplatePreviewImages(response.data);
          if (preselectId !== undefined) setCurrentTemplateId(preselectId);
    } catch (error) {
      console.log(error);
    }
  }
  

useEffect(() => {
 if (routeParams.id === undefined) {
           // console.log('New');
        }
       else {
         getSnippetInfo(routeParams.id);
        }
}, []);

useEffect(() => {
    if (workflowTemplatePreviewImages == null) getTemplatePreviewImagesInfo();
}, [])

useEffect(() => {
  // this is necessary for the edit. 
  // when editing we don't have some objects defined and we need to run "setCurrentTemplateId"
  // in order to have a consistent state
  if (activeStep === 1 && routeParams.id !== undefined) {
    setCurrentTemplateId(snippetInfo.templateId);
  }

}, [activeStep])

const moveToNextStep = () => {

   const isValidStep = validateStep(activeStep);
   if (isValidStep) {  
     setActiveStep(activeStep + 1);
   }
 }

 const moveToPreviousStep = () => {        
   setActiveStep(activeStep - 1);
 }

 const validateStep = (numStep) => {
   let isValid = true;
   isValid = true;

   switch(numStep) {
        case 0:
            break;
        case 1:
            try {
              snippetDataValidationSchemaWeatherForecasts.validateSync(snippetInfo, {abortEarly: false});
              setActiveErrorList([])

            }
            catch (e) {
              const errorList = getErrorListFromYupError(e)
              setActiveErrorList(errorList)
              isValid = false;
            }
            break;
        case 2:
            break;
        default:
           break;
     }
     //console.log(isValid)
     return isValid;
 }

const setCurrentTemplateId = (id) => {
  const newSnippetInfo = {...snippetInfo, templateId: id, filters: [], orderBy: []} // filters and orderBy are reset because if you change a dataConnection you need to work with different fields and previous filter won't be valid
  setSnippetInfo(newSnippetInfo);
  getTemplateMetadata(id)
  const dataConId = getDataConnectionIdOfTemplate(id)
}
const getDataConnectionIdOfTemplate = (templateId) => {
    const template = workflowTemplatePreviewImages.find(tInfo => tInfo.templateId === templateId);
    return template.dataConnectionId;
}

/*
const handleChange = (propName, propValue) => {
  const newSnippetInfo = {...snippetInfo, [propName]: propValue}
  setSnippetInfo(newSnippetInfo);
}
*/


const submitData = async () => {
  try {
    console.log(snippetInfo)
    snippetDataValidationSchemaWeatherForecasts.validateSync(snippetInfo, {abortEarly: false});
    setActiveErrorList([])
    //manually validate default image

  }
  catch (e) {
    const errorList = getErrorListFromYupError(e)
    setActiveErrorList(errorList)
    //console.log(errorList)
    return false;
  }

  setShowLoader(true);
  setSubmitLoading(true);
  setSuccessHtmlMsg('');
  const dataToPost = {...snippetInfo, snippetSettings: JSON.stringify(snippetInfo.snippetSettings)}

  try {
  let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/18`;
  if (routeParams.id !== undefined) url = `${process.env.REACT_APP_LION_API_URL}/Snippets/update/18/${routeParams.id}`;
  // console.log(snippetInfo)
  const response = await axios.post(url, dataToPost);
  setSuccessHtmlMsg(response.data);
  setShowSuccessMsg(true);
  } catch (error) {
  setShowSuccessMsg(false);
  setShowErrorMsg(true);
  console.log(error);
  }
  setShowLoader(false);
  setSubmitLoading(false);
  return true;
}


const copyHtmlCodeToClipboard = (code) => {
setSnackBarClipboardOpen(true);
navigator.clipboard.writeText(code);
}
const handleCloseSnackBarClipboard = () => {
setSnackBarClipboardOpen(false);
}
const SnackBarAction = (
<>
 <IconButton
   size="small"
   aria-label="close"
   color="inherit"
   onClick={handleCloseSnackBarClipboard}
 >
   <Iconify icon={lionIcons.Icon_Actions_Cancel} />
 </IconButton>
</>
);



const handleSaveExitClicked = () => {
  navigate("/ph/forecasts")
}
const handleNextClicked = (tId, tJson) => {
  setTemplateId(tId)
  setTemplateMetadata(tJson)
  const newSnippetInfo = {...snippetInfo, templateId: tId}
  console.log(newSnippetInfo)
  setSnippetInfo(newSnippetInfo)
  setActiveStep(1);
}
const handleSnippetChange = (newSnippetInfo) => {
  setSnippetInfo(newSnippetInfo)
  try {
    snippetDataValidationSchemaWeatherForecasts.validateSync(newSnippetInfo, {abortEarly: false});
    setActiveErrorList([])
  }
  catch (e) {
    const errorList = getErrorListFromYupError(e)
    setActiveErrorList(errorList)
  }

  //console.log(newSnippetInfo)
}
const handleSubmit = async() => {
  const isValid = await submitData()
  if (isValid) setActiveStep(2);
}

 return <>

{!addMode && <>
         <CcStepper2
            steps={[{ name: 'Create Template', href: '#' },
                    { name: 'Element', href: '#' },
                    { name: 'Confirm', href: '#' },
                ]}
            currentStepIndex={activeStep}
        />

      {activeStep === 0 &&
              <TemplateEditor id={templateId}
              embeddedInWizard
              //onPreviousClicked={() => setActiveStep(1)}
              onSaveExitClicked={handleSaveExitClicked}
              onNextClicked={handleNextClicked}
              buildFromDictionary={{...preEditorProps, dataConnectionId: workflowDataConnectionId}}
              //closingCall={() => {setAddEditMode(false); setTemplateIdToEdit(null)}}
              snippetTypeId={18}

              />
      }


{ activeStep === 1 && <ForecastsElementManager
                        templateId={templateId}
                        //dataConnectionId={workflowDataConnectionId}
                        snippetInfo={snippetInfo}
                        //availableFilters={availableFilters}
                        //availableFieldsForOrderBy={availableFieldsForOrderBy}
                        //availableFieldsForHref={availableFieldsForHref}
                        templateMetadata={templateMetadata}
                        onChange={handleSnippetChange}
                        //onNumSnippetsChange={(num) => setWorkflowNumSnippetsToCreate(num)}
                        validationErrorsList={activeErrorList}
                        />

}

{
       activeStep === 2 &&
         <Stack display='flex' justifyContent='center' alignItems='center'>

          {showLoader && <CircularProgress size={64} /> }
           {showSuccessMsg && <Stack spacing={4}><Alert severity="success" sx={{ml:'15%', mr:'15%'}}
                               >
                           <AlertTitle>Success</AlertTitle>
                           <Typography>Element created successfully</Typography>
                         </Alert>
                         <SnippetHtmlViewer numSnippets={1}
                                            weatherMode={weatherModeTag}
                                            html={successHtmlMsg} />

                        <div className='flex flex-row w-[676px]'><div className='mt-6 text-ccColorDarkTeal text-lg font-semibold'>Merge codes</div></div>
                        <div class="inline-flex w-[676px] rounded-md shadow-sm font-poppins text-ccColorDarkTeal" role="group">
                                  <div className={`cursor-pointer px-4 py-2 w-56 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-s-lg hover:bg-gray-100 hover:text-ccColorTeal ${weatherModeTag === 'city' ? 'bg-gray-200' : 'bg-white'}`}
                                        onClick={()=>setweatherModeTag('city')}
                                        >
                                    <div>
                                      City & Country
                                    </div>
                                    <div className='text-sm mt-2 font-normal'>Merge cities and country codes as the locations to have the forecasts for</div>
                                  </div>
                  {/*
                                  <div className={`cursor-pointer px-4 py-2 w-56 font-medium border-t border-b border-gray-200 focus:outline-none focus:ring-0 hover:bg-gray-100 hover:text-ccColorTeal ${props.units === 'metric' ? 'bg-gray-200' : 'bg-white'}`}
                                      //onClick={()=>handleUnitsChange('metric')}
                                      >
                                    <div>
                                    City & Country & State
                                    </div>
                                    <div className='text-sm mt-2 font-normal'>For temperature in Celsius and wind speed in meter/sec</div>
                                  </div>
                  */}
                                  <div className={`cursor-pointer px-4 py-2 w-56 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-e-lg hover:bg-gray-100 hover:text-ccColorTeal ${weatherModeTag === 'state' ? 'bg-gray-200' : 'bg-white'}`}
                                      onClick={()=>setweatherModeTag('state')}
                                      >
                                    <div>
                                    City & Country & State
                                    </div>
                                    <div className='text-sm mt-2 font-normal'>Merge also a state if you need forecasts for ambiguous city names, e.g. London, US, Kentucky and London, US, Ohio</div>
                                  </div>
                        </div>


                         </Stack>}

           {showErrorMsg && <Alert severity="error">
             <AlertTitle>Error</AlertTitle>
             Something went wrong while saving your snippet
           </Alert>}
         </Stack>
   }


{activeStep !== 0 &&
   <Box display="flex" justifyContent="flex-end" sx={{m:1}} >
     {(!showSuccessMsg && !showErrorMsg) && activeStep > 0 && <Button variant="contained" onClick={moveToPreviousStep} sx={{mr:1, backgroundColor: ccColorTeal, ":hover":{backgroundColor: ccColorDarkTeal}}}>Previous</Button>} 
     {/*(!showSuccessMsg && !showErrorMsg) && activeStep < 2 && <Button sx={{backgroundColor: ccColorTeal, ":hover":{backgroundColor: ccColorDarkTeal}}} variant="contained" onClick={moveToNextStep} 
                                                                    
                                                                    >Next</Button>*/}
     {(!showSuccessMsg && !showErrorMsg) && activeStep === 1 && <LoadingButton sx={{backgroundColor: ccColorTeal, ":hover":{backgroundColor: ccColorDarkTeal}}} variant="contained" 
           onClick={handleSubmit} 
           loading={submitLoading} >Submit</LoadingButton>}
     {(showSuccessMsg || showErrorMsg) && <Button variant="contained" href='/ph/forecasts'>Close</Button>}
 </Box>
}

 <Snackbar
   anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
   open={snackBarClipboardOpen}
   autoHideDuration={1500}
   onClose={handleCloseSnackBarClipboard}
   message="Copied to clipboard"
   action={SnackBarAction}
 />

</>}

 </>
}
